module.exports = __webpack_public_path__ + "static/media/Ganni-white-print-tshirt_thumb.48052380.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/some-extra- womenswear- product-shots/thumbs/Ganni-white-print-tshirt_thumb.png
// module id = 322
// module chunks = 0